import toJS from 'shared/components/toJS';
import { connect } from 'react-redux';
import withRouter from '../../shared/utils/WithRouter';
import SalespersonRequired from './SalespersonRequired';

const mapStateToProps = state => ({
	settings: state.cache.get('settings'),
});

// generate a route-aware container component
const SalespersonRequiredContainer = withRouter(
	connect(mapStateToProps)(toJS(SalespersonRequired)),
);

export default SalespersonRequiredContainer;
